import httpFetch from '../common/httpFetch/httpFetch';
import { backendServer } from '../common/config';
import { Team } from '../models/Team';
import { TeamLifecycleSnapshot } from '../models/LifecycleSnapshot';
import { TeamLifecycleEvent } from '../models/TeamLifecycleEvent';

export const createTeam = async (): Promise<Response> => {
  return httpFetch(`${backendServer()}/teams`, {
    method: 'POST',
  });
};

export const fetchTeams = async (...rest: unknown[]): Promise<Array<Team>> => {
  const response = await httpFetch(`${backendServer()}/teams`, {
    method: 'GET',
  });
  return response.json();
};

export const performLifecycleTransition = async (event: TeamLifecycleEvent): Promise<TeamLifecycleSnapshot> => {
  const response = await httpFetch(`${backendServer()}/teams/default/lifecycle`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(event),
  });
  return response.json();
};
